import { render, staticRenderFns } from "./secretariats.vue?vue&type=template&id=7b48e64c&scoped=true"
import script from "./secretariats.vue?vue&type=script&lang=js"
export * from "./secretariats.vue?vue&type=script&lang=js"
import style0 from "./secretariats.vue?vue&type=style&index=0&id=7b48e64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b48e64c",
  null
  
)

export default component.exports